import { CalendarRange } from "lucide-react";
import { DateField } from "@/components/DateField";
import { useState } from "react";

export const PeriodLoader = ({ busy, onLoad }) => {
  const [mode, setMode] = useState("7");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const body = mode === "range" ? { date_from: from, date_to: to || null } : { days: Number(mode) };
  return (
    <div className="inbox-period" data-testid="inbox-period">
      <CalendarRange size={15} />
      <select value={mode} onChange={(e) => setMode(e.target.value)} data-testid="inbox-period-select">
        <option value="7">7 derniers jours</option>
        <option value="30">30 derniers jours</option>
        <option value="90">90 derniers jours</option>
        <option value="range">D'une date à une autre…</option>
      </select>
      {mode === "range" && (
        <>
          <DateField value={from} max={to || undefined} onChange={setFrom} placeholder="Début" testid="inbox-period-from" />
          <span>au</span>
          <DateField value={to} min={from || undefined} onChange={setTo} placeholder="Fin" testid="inbox-period-to" />
        </>
      )}
      <button type="button" className="secondary-button" disabled={busy || (mode === "range" && !from)} onClick={() => onLoad(body)} data-testid="inbox-period-load">
        {busy ? "Chargement…" : "Charger les e-mails"}
      </button>
    </div>
  );
};
